import React from "react";

const DevLog2 = React.forwardRef((props, ref) => {
  const heading = "Promo Material!";
  const date = "28th March 2022";
  return (
    <div ref={ref}>
      {/* // ! Do not change positions */}
      <h1>{heading}</h1>
      <h4>{date}</h4>
      <div>
        <p>
          <strong>
            Hello everyone and welcome to our fifth Discovery Log!
          </strong>
        </p>
        <br />
        <div>
          <p>
            As we come closer to our first release, we have started building our
            promotional material. Please have a look!
          </p>
          <br />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "row",
              margin: "0 auto",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p>
              Take your favourite co-op partner on an adventure into a vibrant
              and mysterious world as you leave your home village behind in
              search of powerful new technology. Having lived your lives in the
              shadows of giant mechanical beings, you soon realize there is more
              of the world left to discover. Each equipped with your own unique
              set of heirloom tools, you must work together to traverse these
              massive mechs, fight alongside each other to defeat rogue robots,
              and solve challenging puzzles on your journey to save your home
              from the edge of destruction.
            </p>
            <br />
            <br />
            <img
              src="../landingImages/PromoMaterial_Page_1.jpg"
              alt="Overview"
              style={{
                maxWidth: "min(100%, 25rem)",
                width: "auto",
                marginRight: "2rem",
                height: "fit-content",
                marginTop: "1rem",
              }}
            />
            <img
              src="../landingImages/PromoMaterial_Page_2.jpg"
              alt="Overview"
              style={{
                maxWidth: "min(100%, 25rem)",
                width: "auto",
                marginRight: "2rem",
                height: "fit-content",
                marginTop: "1rem",
              }}
            />
            <img
              src="../landingImages/PromoMaterial_Page_3.jpg"
              alt="Overview"
              style={{
                maxWidth: "min(100%, 25rem)",
                width: "auto",
                marginRight: "2rem",
                height: "fit-content",
              }}
            />
            <img
              src="../landingImages/PromoMaterial_Page_4.jpg"
              alt="Overview"
              style={{
                maxWidth: "min(100%, 25rem)",
                width: "auto",
                marginRight: "2rem",
                height: "fit-content",
              }}
            />
            <img
              src="../landingImages/PromoMaterial_Page_5.jpg"
              alt="Overview"
              style={{
                maxWidth: "min(100%, 25rem)",
                width: "auto",
                marginRight: "2rem",
                height: "fit-content",
              }}
            />
            <img
              src="../landingImages/PromoMaterial_Page_6.jpg"
              alt="Overview"
              style={{
                maxWidth: "min(100%, 25rem)",
                width: "auto",
                marginRight: "2rem",
                height: "fit-content",
              }}
            />
          </div>
          <br />
          <p>See you next week with another Discovery Log!</p>
          <br />
          <br />- Particle Interactive
        </div>
      </div>
    </div>
  );
});

export default DevLog2;
